export default "__VITE_ASSET__cb5mTW2r__"